import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { isNullOrUndefined } from '@uzurv/rideWss/app/util';
import { HttpException } from '@uzurv/rideWss/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class HttpExceptionMappingInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        if (err instanceof HttpErrorResponse) {
          let message: string = err.statusText;
          if (!isNullOrUndefined(err.error)) {
            message = err.error.status;
          }

          if (isNullOrUndefined(message) || message.length === 0) {
            if (err.status === 401) {
              message = 'Unauthorized';
            } else if (err.status === 404) {
              message = 'URL Not Found';
            } else if (err.status === 403) {
              message = 'This action is forbidden';
            } else if (err.status === 504) {
              message = 'The server took too long to respond';
            } else {
              message = 'Unknown Error';
            }
          }

          return throwError(() => new HttpException(err.status, message));
        } else {
          return throwError(() => err);
        }
      })
    );
  }
}
